module.exports = __webpack_public_path__ + "img/touxiang1.8e80ab9e.png";